import { useState } from "react";
import { Box, Button, Divider, Grid } from "@mui/material";
import { t } from "i18next";
import AppConfig from "../../../../../helpers/constants/AppConfig";
import CustomModal from "../../../../../components/Modal";
import SiteSelect from "../../../../../components/SiteSelect";
import CacehUsePie from "../../../../../components/CacheUsePie";

function CacheUse({ domain, setOpen }) {
  const [graphData, setGraphData] = useState({});
  const [errors, setErrors] = useState({});
  const [filterData, setFilterData] = useState({
    ip: ""
  });

  const handleChange = (e, name) => {
    setFilterData({
      ...filterData,
      [name]: e
    });
    setErrors({
      ...errors,
      [name]: null
    });
  };

  const onSearch = () => {
    let temp_errors = {};

    if (filterData.ip === "") {
      temp_errors.ip = t("message.required", { item: t("site.site") });
    }

    setErrors(temp_errors);

    if (Object.keys(temp_errors).length === 0) {
      setGraphData({
        ...filterData,
        domainId: domain?.id
      });
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
     <CustomModal
        open={true}
        handleClose={handleClose}
        title={t("domain.cache_use")}
     >
       <Box py={2} px={{ md: 5, xs: 0 }}>

         <Grid container spacing={3} justifyContent="center">
           <Grid container justifyContent="center"
                 sx={{ mt: 2, mb: 1 }} alignItems="start"
           >
             <Grid item md={4} xs={12}>
               <SiteSelect
                  value={filterData.ip}
                  onChange={(e) => handleChange(e.target.value, "ip")}
                  error={errors?.ip}
               />
             </Grid>

             <Grid item md={12} xs={12} mt={2} className="d-flex justify-content-center">
               <Button
                  onClick={onSearch}
                  variant="outlined" color={AppConfig.color} className="button-fw-normal"
               >
                 {t("button.view")}
               </Button>
             </Grid>
           </Grid>

           <div className="divider-div">
             <Divider />
           </div>

           {graphData?.ip &&
              <CacehUsePie
                 graphData={graphData}
              />
           }

         </Grid>
       </Box>

     </CustomModal>
  );
}

export default CacheUse;
